import type { CurrencyCode } from '../types';

/** Canonical currency codes accepted by the subscriptions backoffice. */
export const SUPPORTED_CURRENCY_CODES: CurrencyCode[] = ['BRL', 'USD'];
